(function () {
    'use strict';

    angular
        .module('editorApp')
        .controller('EditorStructurePartSizeController', EditorStructurePartSizeController);

    EditorStructurePartSizeController.$inject = ['$scope', '$uibModalInstance', 'part'];

    function EditorStructurePartSizeController($scope, $uibModalInstance, part) {
        var vm = this;

        // TODO: 尺寸为前端示例数据，刀线尺寸与组件的联动计算接入后端后替换
        vm.cutline = {
            width: part.cutlineWidth,
            height: part.cutlineHeight
        };
        vm.physical = {
            width: part.physicalWidth,
            height: part.physicalHeight
        };
        vm.links = {
            cutline: false,
            physical: false
        };
        vm.invalid = {
            cutline: false,
            physical: false
        };

        var ratios = {
            cutline: ratioOf(vm.cutline),
            physical: ratioOf(vm.physical)
        };

        function ratioOf(size) {
            var width = parseFloat(size.width);
            var height = parseFloat(size.height);
            return width > 0 && height > 0 ? width / height : 1;
        }

        $scope.toggleLink = function (key) {
            vm.links[key] = !vm.links[key];
            if (vm.links[key]) {
                ratios[key] = ratioOf(vm[key]);
            }
        };

        $scope.onSizeChange = function (key, dimension) {
            vm.invalid[key] = false;
            if (!vm.links[key]) {
                return;
            }
            var size = vm[key];
            var ratio = ratios[key];
            var width = parseFloat(size.width);
            var height = parseFloat(size.height);
            if (dimension === 'width' && width > 0) {
                size.height = Math.max(1, Math.round(width / ratio));
            } else if (dimension === 'height' && height > 0) {
                size.width = Math.max(1, Math.round(height * ratio));
            }
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

        $scope.confirm = function () {
            var cutlineWidth = positiveNumber(vm.cutline.width);
            var cutlineHeight = positiveNumber(vm.cutline.height);
            var physicalWidth = positiveNumber(vm.physical.width);
            var physicalHeight = positiveNumber(vm.physical.height);

            vm.invalid.cutline = !(cutlineWidth && cutlineHeight);
            vm.invalid.physical = !(physicalWidth && physicalHeight);
            if (vm.invalid.cutline || vm.invalid.physical) {
                return;
            }

            $uibModalInstance.close({
                cutlineWidth: cutlineWidth,
                cutlineHeight: cutlineHeight,
                physicalWidth: physicalWidth,
                physicalHeight: physicalHeight
            });
        };

        function positiveNumber(value) {
            var number = parseFloat(value);
            return isFinite(number) && number > 0 ? Math.round(number * 100) / 100 : null;
        }
    }
})();
